import React, { useEffect, useState } from "react";
import axios from "axios";
import { useOutletContext } from "react-router-dom";
import toastr from "../../../utils/toast";
import { type } from "jquery";

function ABAllocation({ onClose, roleId, reference }) {
  const [eligibleUsers, setEligibleUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [loading, setLoading] = useState(false);
  const [isConsultant, setIsConsultant] = useState(true); // toggle state
  const [TotalAllocation, setTotalAllocation] = useState(0);

  const { token, setGlobalLoading } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // Fetch eligible users
  useEffect(() => {
    if (!roleId) return;

    const fetchEligibleUsers = async () => {
      try {
        setGlobalLoading(true);
        const res = await axios.post(
          `${API_BASE_URL}/roles/allocations/add`,
          { role_id: roleId, user_id:null, isconsultant:0, type: "AB"}, // request only eligible users
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setEligibleUsers(res.data.eligibleUsers || []);
        setTotalAllocation(res.data.count || 0);
      } catch (err) {
        console.error("Error fetching eligible users:", err);
        setEligibleUsers([]);
      } finally {
        setGlobalLoading(false);
      }
    };

    fetchEligibleUsers();
  }, [roleId]);

  useEffect(() => {
    console.log(TotalAllocation);
    if (TotalAllocation >= 3) {
      alert(
        "There already a resource allocated, if you want to add another then you have to make the resource inactive."
      );
      onClose();
    }
  }, [TotalAllocation]);

  // Allocate user
  const handleAllocate = async () => {
    if (!selectedUser) {
      toastr.error("Please select a user");
      return;
    }

    try {
      setGlobalLoading(true);
      await axios.post(
        `${API_BASE_URL}/roles/allocations/add`,
        {
          role_id: roleId,
          user_id: selectedUser,
          isconsultant: 0,
          type: "AB",
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      isConsultant
        ? toastr.success("User target allocated successfully")
        : toastr.success("User allocated successfully");

      setSelectedUser("");
      onClose();
    } catch (err) {
      console.error("Allocation failed:", err);
      toastr.error(err.response?.data?.message || "Failed to allocate user");
    } finally {
      setGlobalLoading(false);
    }
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "500px" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Allocate User (Reference: {reference})
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">Select User</label>
              <select
                className="form-select"
                value={selectedUser}
                onChange={(e) => setSelectedUser(e.target.value)}
                disabled={eligibleUsers.length === 0 || loading}
                required
              >
                <option value="">-- Select User --</option>
                {eligibleUsers.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.firstname} {user.lastname} ({user.designation_name})
                  </option>
                ))}
              </select>
            </div>

            {/* Toggle for target allocation */}
            {/* <div className="form-check form-switch mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="targetSwitch"
                checked={isConsultant}
                onChange={(e) => setIsConsultant(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="targetSwitch">
                Target Allocation
              </label>
            </div> */}

            {eligibleUsers.length === 0 && (
              <p className="text-muted">No eligible users available.</p>
            )}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-success ms-2"
              onClick={handleAllocate}
              disabled={!selectedUser || loading}
            >
              Allocate
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ABAllocation;
